const PREFIX = "abos.store-bridge.device.v1";
export const STORE_BRIDGE_CHANGED_EVENT = "abos:store-bridge-selection-changed";

function key(workspacePublicId, storePublicId) {
  if (!workspacePublicId || !storePublicId) return "";
  return `${PREFIX}:${workspacePublicId}:${storePublicId}`;
}

function emit(workspacePublicId, storePublicId, deviceId) {
  if (typeof window === "undefined") return;
  try {
    window.dispatchEvent(new CustomEvent(STORE_BRIDGE_CHANGED_EVENT, {
      detail: {
        workspace_public_id: workspacePublicId,
        store_public_id: storePublicId,
        device_id: deviceId || null,
      },
    }));
  } catch {
    // Workstation selection is convenience state only.
  }
}

export function getSelectedStoreBridgeDeviceId(workspacePublicId, storePublicId) {
  const storageKey = key(workspacePublicId, storePublicId);
  if (!storageKey || typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(storageKey) || null;
  } catch {
    return null;
  }
}

export function setSelectedStoreBridgeDeviceId(workspacePublicId, storePublicId, deviceId) {
  const storageKey = key(workspacePublicId, storePublicId);
  if (!storageKey || typeof window === "undefined") return;
  try {
    if (deviceId) window.localStorage.setItem(storageKey, deviceId);
    else window.localStorage.removeItem(storageKey);
    emit(workspacePublicId, storePublicId, deviceId || null);
  } catch {
    // Hardware selection never changes sale correctness.
  }
}

export function createStoreBridgeJobKey(prefix = "store-bridge") {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `${prefix}-${crypto.randomUUID()}`;
  }
  return `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
